import { useCallback } from "react";
import { useEnvironmentState } from "../context";
import { useFetch } from "./useFetch";

export function useUploadImage(onUploaded?: (image: { id: string }) => void) {
  const { backendBaseUrl } = useEnvironmentState();

  const [fetch, { data, loading, error }] = useFetch<{
    id: string;
  }>(`${backendBaseUrl}/image/upload`, {
    onFetchSuccess: onUploaded,
  });

  const computeImageUrl = useCallback(
    (id: string) => {
      return `${backendBaseUrl}/image/${id}`;
    },
    [backendBaseUrl]
  );

  const uploadImage = useCallback(
    (file: File) => {
      const formData = new FormData();
      formData.append("file", file);

      return fetch({
        method: "POST",
        body: formData,
      });
    },
    [fetch]
  );

  return { uploadImage, computeImageUrl, data, loading, error };
}
